var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, Button, CircularProgress, Grid } from "@mui/material";
import { Upload } from "./modules/upload/Upload";
import { WebcamCapture } from "./modules/webcam/WebcamCapture";
import React, { useState } from "react";
import SendIcon from "@mui/icons-material/Send";
import axios from "axios";
export var App = function () {
    var _a = useState(null), base64 = _a[0], setBase64 = _a[1];
    var _b = useState(null), base64WebCam = _b[0], setBase64WebCam = _b[1];
    var _c = useState(false), statusVerify = _c[0], setStatusVerify = _c[1];
    var _d = useState(false), loading = _d[0], setLoading = _d[1]; // Estado para o carregamento
    var handleUpload = function (files) {
        if (!files || files.length === 0)
            return;
        var file = files[0];
        var reader = new FileReader();
        reader.onload = function () {
            if (reader.result) {
                console.log("Base64 do arquivo ".concat(file.name, ":"), reader.result);
                setBase64(reader.result);
                // Aqui você pode enviar o resultado para uma API ou usá-lo conforme necessário
            }
        };
        reader.onerror = function (error) {
            console.error("Erro ao converter o arquivo ".concat(file.name, " para Base64:"), error);
        };
        reader.readAsDataURL(file);
    };
    var handleCapture = function (base64) {
        setBase64WebCam(base64);
    };
    return (_jsxs(Grid, __assign({ container: true, spacing: 2 }, { children: [_jsx(Grid, __assign({ item: true, xs: 12, md: 6 }, { children: _jsx(Upload, { onUpload: handleUpload }) })), _jsx(Grid, __assign({ item: true, xs: 12, md: 6 }, { children: _jsx(WebcamCapture, { onCapture: handleCapture }) })), _jsx(Grid, __assign({ item: true, xs: 12, md: 6 }, { children: _jsx(Button, __assign({ variant: "contained", startIcon: _jsx(SendIcon, {}), component: "label", onClick: function () {
                        setLoading(true);
                        var payload = {
                            img1: base64,
                            img2: base64WebCam,
                            model_name: "Facenet",
                            detector_backend: "mtcnn",
                            distance_metric: "euclidean",
                            anti_spoofing: true,
                        };
                        axios
                            .post("https://reconhecimento-facial-backend.api.demo-aws.xvia.com.br/verify", payload)
                            .then(function (response) {
                            console.log("Response data: ", response.data);
                            setStatusVerify(response.data.verified);
                        })
                            .catch(function (error) {
                            console.error("Error: ", error);
                        })
                            .finally(function () {
                            setLoading(false); // Desativa o carregamento após a resposta
                        });
                    } }, { children: "Validar" })) })), statusVerify === false && loading ? (_jsx(Grid, __assign({ item: true, xs: 12, md: 6 }, { children: _jsxs(Alert, __assign({ severity: "info" }, { children: [_jsx(CircularProgress, { size: 24 }), "Carregando..."] })) }))) : (statusVerify !== null && (_jsx(Grid, __assign({ item: true, xs: 12, md: 6 }, { children: _jsx(Alert, __assign({ severity: statusVerify ? "success" : "error" }, { children: statusVerify ? "Validado com sucesso!" : "Falha na validação!" })) }))))] })));
};
